import React from 'react'
import { Link } from 'react-router-dom'

export default function ProfileBlock(props){
  const {
    // currentUser,
    homepageBlock,
    profileImage,
    messageCount,
  } = props

  if(homepageBlock.image) {
    return (
      <Link
        className="fa-stack fa-3x"
        to={ homepageBlock.type_key }
        key={ homepageBlock.id }>
        <img
          src={ homepageBlock.image }
          alt='' />
      </Link>
    )
  }
  // else if(currentUser.block_messages) {
  //   // do not show alert if current user blocked messages
  //   return (
  //     <span
  //       className="fa-stack fa-3x"
  //       key={ homepageBlock.id }>
  //       <Link
  //         to={ homepageBlock.type_key }>
  //         <div
  //           className="homepage-block">
  //           { homepageBlock.title }
  //           { profileImage }
  //         </div>
  //       </Link>
  //     </span>
  //   )
  // }
  else {
    // DO show alert if current user has NOT blocked messages
    return (
      <span
        className="fa-stack fa-3x has-badge"
        data-count={ messageCount }
        key={ homepageBlock.id }>
        <Link
          to={ homepageBlock.type_key }>
          <div
            className="homepage-block">
            { homepageBlock.title }
            { profileImage }
          </div>
        </Link>
      </span>
    )
  }
}
